import { render, staticRenderFns } from "./AppendComponent.vue?vue&type=template&id=67e6af13&lang=pug&"
import script from "./AppendComponent.vue?vue&type=script&lang=js&"
export * from "./AppendComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports